import { useEffect, useState, useCallback } from 'react';
import { lclClient } from '../api/lclClient';
import toast from 'react-hot-toast';

export function useLclBatches({ type = '', from = '', to = '' } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    setLoading(true);
    try { setData(await lclClient.listBatches({ type, from, to })); }
    catch (e) { toast.error(`Historique: ${e.message}`); }
    finally { setLoading(false); }
  }, [type, from, to]);

  useEffect(() => { refetch(); }, [refetch]);
  return { data, loading, refetch };
}
